module.exports = __webpack_public_path__ + "static/media/false.f117c900.png";